import type { RxJsonSchema } from 'rxdb';
import type { CustomerDocType } from '../types/customer';

export const customerSchema: RxJsonSchema<CustomerDocType> = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 36 },
    name: { type: 'string', maxLength: 100 },
    phone: { type: 'string', maxLength: 15 },
    email: { type: 'string', maxLength: 100 },
    address: { type: 'string', maxLength: 500 },
    notes: { type: 'string', maxLength: 500 },
    totalSpent: { type: 'number', default: 0 },
    visitCount: { type: 'number', default: 0 },
    createdAt: { type: 'string' },
    updatedAt: { type: 'string' },
    _deleted: { type: 'boolean', default: false },
  },
  required: ['id', 'name', 'phone', 'createdAt', 'updatedAt'],
  indexes: ['phone', 'email'],
};
